import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store';
import './header.scss';
import Logo from '../../assets/images/logo.svg';

const Header = () => {
  const { t } = useTranslation('', { keyPrefix: 'PAGE_HEADER' });
  const { tenantStore } = useStore();
  const assistancePhoneNumber = tenantStore.config.assistancePhoneNumber;
  return (
    <header>
      <div className="header-left">
        <img src={Logo} alt="net2phone" />
        <h1>{t('TITLE')}</h1>
      </div>
      {assistancePhoneNumber && (
        <div data-html2canvas-ignore="true">
          <h1>{t('CALL_NUMBER', { number: assistancePhoneNumber })}</h1>
        </div>
      )}
    </header>
  );
};

export default Header;
